import { CdkDrag, CdkDragMove } from '@angular/cdk/drag-drop';
import { AfterViewInit, Directive, Input, output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { CalendarEvent } from '../calendar.models';
import { pixelsToTime } from '../utils/calendar-event.utils';

@UntilDestroy()
@Directive({
  selector: '[blazeEventDragMove]',
  standalone: false,
})
export class EventDragMoveDirective implements AfterViewInit {
  eventMoved = output<{ h: number; m: number }>();

  @Input('blazeEventDragMove') drag!: CdkDrag<CalendarEvent>;
  @Input() oneHourHeight!: number;

  ngAfterViewInit(): void {
    const roundTo = this.oneHourHeight / 4;

    this.drag.moved.pipe(untilDestroyed(this)).subscribe((event: CdkDragMove) => {
      const placeholderY = event.distance.y - (event.distance.y % roundTo);
      const placeholderEl = document.getElementsByClassName(
        'cdk-drag-placeholder',
      )[0] as HTMLElement;
      placeholderEl.style.transform = `translateY(${placeholderY}px)`;
      this.eventMoved.emit(pixelsToTime(placeholderY, this.oneHourHeight));
    });
  }
}
